import Heading from '@components/web/heading/Heading.tsx';
import { Button, Grid, Textarea, TextInput } from '@inexture/core';
import { useState } from 'react';
import { useContactFormMutation } from '@/services/contact.service';
import { toast } from 'sonner';
import { z } from 'zod';

const contactSchema = z.object({
  name: z.string().trim().min(1, 'Naam is verplicht'),
  email: z.string().trim().email('Ongeldig e-mailadres'),
  phone: z.string().optional(),
  message: z.string().optional()
});

const ContactUs = () => {
  const [form, setForm] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });

  const [sendContact, { isLoading }] = useContactFormMutation();

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const parsed = contactSchema.safeParse(form);

    if (!parsed.success) {
      const firstError = parsed.error.issues[0]?.message ||
        'Vul alle verplichte velden correct in.';
      toast.error(firstError);
      return;
    }

    try {
      const payload = parsed.data;

      await sendContact({
        name: payload.name,
        email: payload.email,
        phone: payload.phone?.trim() || undefined,
        message: payload.message?.trim() || ''
      })
        .unwrap()
        .then(data => {
          console.log('first', data);
          setForm({ name: '', email: '', phone: '', message: '' });
          toast.success(data?.message || 'Uw bericht is succesvol verzonden.');
        })
        .catch(err => {
          toast.error(
            'Er is een fout opgetreden bij het verzenden van uw bericht.'
          );
          console.error('Failed to send contact message', err);
        });
    } catch (err) {
      console.error('Failed to send contact message', err);
    }
  };

  const update = (key: keyof typeof form) => (val: string) =>
    setForm(prev => ({ ...prev, [key]: val }));

  return (
    <div id="contacteer-ons" className="scroller">
      <Heading title="Contacteer ons" />
      <section className="bg-white antialiased  py-20">
        <div className="container">
          <section className="bg-[#f5f5f5] rounded-lg shadow-sm p-5">
            <div className="grid grid-cols-12 gap-x-8 gap-y-6 items-start">
              <div className="col-span-12 lg:col-span-6">
                <h4 className="text-2xl text-[18px] font-semibold text-[#536878] mb-4">
                  Adres
                </h4>
                <p className="text-sm text-[#666666] mb-4">
                  Reebokdreef 13, 2900 Antwerpen
                </p>
              </div>

              <div className="col-span-12 lg:col-span-3">
                <h4 className="text-2xl font-semibold text-[18px] text-[#536878] mb-4 text-center lg:text-left">
                  Contact
                </h4>
                <p className="text-sm text-[#666666] mb-4 text-center lg:text-left">
                  +32 (3) 707 00 07
                </p>
              </div>

              <div className="col-span-12 lg:col-span-2">
                <h4 className="text-2xl font-semibold text-[18px] text-[#536878] mb-4 ">
                  Support
                </h4>
                <p className="text-sm text-[#666666] mb-4 text-right lg:text-right">
                  support@solvere.be
                </p>
              </div>
              <div className="col-span-12 ">
                <form onSubmit={handleSubmit}>
                  <Grid>
                    <Grid.Col span={{ base: 12, md: 6 }}>
                      <TextInput
                        size="lg"
                        placeholder="Naam"
                        value={form.name}
                        onChange={e => update('name')(e.target.value)}
                      />

                      <div className="grid grid-cols-2 gap-4 mt-5">
                        <TextInput
                          size="lg"
                          placeholder="Email"
                          type="email"
                          value={form.email}
                          onChange={e => update('email')(e.target.value)}
                        />
                        <TextInput
                          size="lg"
                          placeholder="Telefoonnummer"
                          value={form.phone}
                          onChange={e => update('phone')(e.target.value)}
                        />
                      </div>
                    </Grid.Col>
                    <Grid.Col span={{ base: 12, md: 6 }}>
                      <Textarea
                        rows={5}
                        placeholder="Uw bericht"
                        color='primary'
                        value={form.message}
                        onChange={e =>
                          update('message')(
                            (e.target as HTMLTextAreaElement).value
                          )
                        }
                      />

                      <div className="text-end mt-5 w-full">
                        <Button
                          size="lg"
                          type="submit"
                          disabled={isLoading}
                          loading={isLoading}
                        >
                          Verzenden
                        </Button>
                      </div>
                    </Grid.Col>
                  </Grid>
                </form>
              </div>
            </div>
          </section>
        </div>
      </section>
    </div>
  );
};

export default ContactUs;
